import React from "react";
import Navbar from "../navbar/navbar-desktop.tsx";
import Footer from "../footer/footer.tsx";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";
import { FaInstagram, FaFacebook, FaStar, FaGooglePlus } from "react-icons/fa";

function HomePage() {
  return (
    <div className="w-full overflow-x-hidden font-['Libre_Baskerville'] bg-[#F5E7CC]">

      <Helmet>
        <title>Hospůdka pod Rablinů | Domácí kuchyně, ubytování a akce</title>
      </Helmet>

      <Navbar />

      {/* ================= HERO ================= */}
      <section className="relative isolate border-b-2 border-blue-800 px-5 pt-14 pb-10 lg:pt-20 lg:pb-16 overflow-hidden">
        {/* pozadí – fotka exteriéru */}
        <img
          src="./img/exterier/exterier-2.jpg"
          alt=""
          aria-hidden="true"
          loading="eager"
          className="absolute inset-0 -z-20 w-full h-full object-cover object-center"
        />
        {/* ztmavení, aby byl text čitelný na všech rozlišeních */}
        <div
          aria-hidden="true"
          className="absolute inset-0 -z-10 bg-[#2b1205]/70 sm:bg-[#2b1205]/65"
        />

        <div className="relative max-w-5xl mx-auto text-center text-white [text-shadow:0_2px_12px_rgba(0,0,0,0.45)]">
          <p className="text-[11px] lg:text-xs uppercase tracking-[0.28em] text-[#f0d9b5]">
            Penzion a hospůdka v Hostýnských vrších
          </p>

          <h1 className="mt-4 text-3xl lg:text-5xl font-bold !leading-[1.35]">
            Vítejte u nás v Hospůdce pod Rablinů
          </h1>

          <div className="w-12 h-px bg-[#e5c79b] mx-auto mt-6" />

          <p className="mt-6 text-sm lg:text-lg leading-relaxed max-w-3xl mx-auto">
            Náš penzion je zasazen do malebné přírody <b>Hostýnských vrchů</b>, kde na vás
            čeká pohostinná atmosféra a poctivá domácí kuchyně. V areálu najdete také naši
            mini zoo, dětské hřiště, lanovku i letní atrakce.
          </p>

          <p className="mt-4 text-sm lg:text-lg leading-relaxed max-w-3xl mx-auto">
            Zajišťujeme svatby, oslavy, firemní akce a večírky v rodinné atmosféře.
          </p>

          <div className="mt-8 flex flex-col sm:flex-row gap-3 justify-center">
            <Link to="/rezervace" className="w-full sm:w-auto">
              <button className="w-full bg-white hover:bg-[#f3e3c8] transition-colors text-[#60260F] px-10 py-4 rounded-xl text-base lg:text-lg font-semibold">
                Vytvořit rezervaci
              </button>
            </Link>
            <a href="tel:+420608608101" className="w-full sm:w-auto">
              <button className="w-full border border-white/80 text-white hover:bg-white hover:text-[#60260F] transition-colors px-10 py-4 rounded-xl text-base lg:text-lg font-semibold backdrop-blur-sm">
                +420 608 608 101
              </button>
            </a>
          </div>
        </div>
      </section>

      {/* ================= NOVĚ – WELLNESS =================
          jen border-t: spodní linku dělá navazující pás (mobile CTA / aktuality) */}
      <section className="bg-[#FAF0D9] border-t border-blue-800 px-6 py-20 md:py-24 text-center">
        <p className="text-xs md:text-sm uppercase tracking-[0.3em] font-semibold text-[#497CB2]">
          ✦ Novinky ✦
        </p>
        <h2 className="mt-3 text-3xl font-bold text-[#60260F]">
          Wellness &amp; Spa pod Rablinů
        </h2>
        <p className="mt-3 max-w-2xl mx-auto text-sm lg:text-lg leading-relaxed text-[#60260F]">
          Dvě vířivky, finská sauna vytápěná saunovými kamny na dřevo a prosklená
          odpočívárna s výhledem do valašských lesů a luk.
        </p>

        <div className="max-w-7xl mx-auto mt-12 grid grid-cols-2 md:grid-cols-3 gap-4 md:gap-6">
          {[
            { src: "./img/wellness/wellness-uvodni.jpg", popisek: "Venkovní vířivka a odpočívárna" },
            { src: "./img/wellness/wellness-virivka-kryta.jpg", popisek: "Krytá vířivka až pro 5 osob" },
            { src: "./img/wellness/wellness-sauna-finska.jpg", popisek: "Finská sauna na dřevo" },
          ].map((foto, i) => (
            <figure key={foto.src} className={i === 0 ? "col-span-2 md:col-span-1" : ""}>
              <div className="overflow-hidden rounded-xl">
                <img
                  src={foto.src}
                  className={`w-full ${i === 0 ? "h-56" : "h-36"} md:h-64 object-cover hover:scale-105 transition`}
                  alt={`${foto.popisek} – wellness Hospůdky pod Rablinů`}
                  loading="lazy"
                />
              </div>
              <figcaption className="mt-3 text-xs md:text-sm italic text-[#60260F]">
                {foto.popisek}
              </figcaption>
            </figure>
          ))}
        </div>

        <div className="mt-12 flex flex-col md:flex-row justify-center gap-4">
          <Link to="/wellness">
            <button className="border border-[#60260F] bg-[#60260F] hover:bg-[#965126] hover:border-[#965126] text-white w-72 py-4 rounded-xl text-lg font-semibold transition-colors">
              Více o wellness
            </button>
          </Link>
          <Link to="/rezervace-wellness">
            <button className="border border-[#60260F] text-[#60260F] hover:bg-[#60260F] hover:text-white w-72 py-4 rounded-xl text-lg font-semibold transition-colors">
              Rezervovat wellness
            </button>
          </Link>
        </div>
      </section>

      {/* ================= MOBILE CTA ================= */}
      <section className="md:hidden bg-[#FAF0D9] py-16 text-center border-y border-blue-800">
        <h2 className="text-3xl font-bold text-[#60260F]">
          Zamluvte si termín
        </h2>
        <p className="mt-2 mb-8">Na pár kliknutí</p>

        <Link to="/rezervace">
          <button className="px-12 py-4 bg-[#60260F] text-white rounded-lg">
            Vytvořit rezervaci
          </button>
        </Link>
      </section>

      {/* ================= MOBILE IMAGES 1 ================= */}
      <section className="md:hidden px-6 py-16 space-y-6">
        <img
          src="./img/hlavni-interier.jpg"
          className="w-full h-64 object-cover rounded-xl"
          alt="Interiér Hospůdky pod Rablinů"
        />
        <img
          src="./img/aktualni/interior1.jpg"
          className="w-full h-64 object-cover rounded-xl"
          alt="Posezení v interiéru Hospůdky pod Rablinů"
        />
      </section>

      {/* ================= MOBILE CTA AGAIN ================= */}
      <section className="bg-[#FAF0D9] border-y border-blue-800 py-24 text-center">
        <h2 className="text-3xl font-bold text-[#60260F]">
          Nezmeškejte žádné novinky
        </h2>
        <p className="mt-3 mb-10 text-[#60260F]">
          Sledujte naše aktuality
        </p>

        <div className="flex flex-col md:flex-row justify-center gap-6">
          <Link to="/aktuality">
            <button className="w-64 px-8 py-4 bg-[#497CB2] text-white rounded-lg">
              Přejít na aktuality
            </button>
          </Link>

          <Link to="/fotogalerie-pokoje">
            <button className="w-64 px-8 py-4 border border-[#60260F] text-[#60260F] rounded-lg underline">
              Fotografie
            </button>
          </Link>
        </div>
      </section>

      {/* ================= MOBILE IMAGES 2 ================= */}
      <section className="md:hidden px-6 py-16 space-y-6">
        <img
          src="./img/svatby.jpg"
          className="w-full h-64 object-cover rounded-xl"
          alt="Svatební prostředí Hospůdky pod Rablinů"
        />
        <img
          src="./img/rablina2.webp"
          className="w-full h-64 object-cover rounded-xl"
          alt="Areál Hospůdky pod Rablinů v přírodě"
        />
      </section>

      {/* ================= DESKTOP 3 IMAGES ================= */}
      <section className="hidden md:block max-w-7xl mx-auto px-6 py-24">
        <div className="grid grid-cols-3 gap-6">
          {[
            "./img/hlavni-interier.jpg",
            "./img/svatby.jpg",
            "./img/rablina2.webp",
          ].map((img, i) => (
            <img
              key={i}
              src={img}
              className="w-full h-64 object-cover rounded-xl hover:scale-105 transition"
              alt="Fotografie Hospůdky pod Rablinů"
            />
          ))}
        </div>
      </section>

      {/* ================= NOVINKY ================= */}
      <section className="bg-[#FAF0D9] border-y border-blue-800 py-24 text-center">
        <h2 className="text-3xl font-bold text-[#60260F]">
          Chcete uspořádat akci ?
        </h2>
        <p className="mt-3 mb-10 text-[#60260F]">
        Svatba, oslava či jiný typ akcí není žádný problém
        </p>

        <div className="flex flex-col md:flex-row justify-center gap-4">
          <Link to="/rezervace-akce">
            <button className="border border-[#60260F] bg-[#60260F] hover:bg-[#965126] hover:border-[#965126] text-white w-72 py-4 rounded-xl text-lg font-semibold transition-colors">
              Vytvořit rezervaci
            </button>
          </Link>

          <Link to="/fotogalerie-pokoje">
            <button className="border border-[#60260F] text-[#60260F] hover:bg-[#60260F] hover:text-white w-72 py-4 rounded-xl text-lg font-semibold transition-colors">
              Fotografie
            </button>
          </Link>
        </div>
      </section>

      {/* ================= MAP ================= */}
      <section className="w-full h-[400px] border-y border-white">
        <iframe
          className="w-full h-full border-0"
          loading="lazy"
          title="Mapa – Hospůdka pod Rablinů"
          src="https://www.google.com/maps?q=Kašava%20302,%20763%2019&output=embed"
        />
      </section>

      <Footer flush />
    </div>
  );
}

export default HomePage;
